import { useNostrPublish } from './useNostrPublish';
import type { BitcoinBlock } from './useBitcoinBlocks';
import { useToast } from './useToast';

export function usePublishBlock() {
  const { mutateAsync: publish } = useNostrPublish();
  const { toast } = useToast();

  const publishBlock = async (block: BitcoinBlock) => {
    try {
      const content = JSON.stringify({
        merkle_root: block.merkle_root,
        previousblockhash: block.previousblockhash,
        nonce: block.nonce,
        bits: block.bits,
        version: block.version,
      });

      const event = await publish({
        kind: 30333,
        content,
        tags: [
          ['d', block.id],
          ['height', block.height.toString()],
          ['timestamp', block.timestamp.toString()],
          ['tx_count', block.tx_count.toString()],
          ['size', block.size.toString()],
          ['weight', block.weight.toString()],
          ['difficulty', block.difficulty.toString()],
          ['alt', `Bitcoin block #${block.height} mined with ${block.tx_count} transactions`],
        ],
      });

      toast({
        title: 'Block Published to Nostr',
        description: `Block #${block.height} has been immortalized on Nostr!`,
      });

      return event;
    } catch (error) {
      toast({
        title: 'Failed to Publish Block',
        description: error instanceof Error ? error.message : 'Unknown error occurred',
        variant: 'destructive',
      });
      throw error;
    }
  };

  return { publishBlock };
}
